var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkkeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.79 14.9298C17.73 16.9798 14.78 17.6098 12.19 16.7998L7.48002 21.4998C7.14002 21.8498 6.47002 22.0598 5.99002 21.9898L3.81002 21.6898C3.09002 21.5898 2.42002 20.9098 2.31002 20.1898L2.01002 18.0098C1.94002 17.5298 2.17002 16.8598 2.50002 16.5198L7.20002 11.8198C6.40002 9.21982 7.02002 6.26982 9.08002 4.21982C12.03 1.26982 16.82 1.26982 19.78 4.21982C22.74 7.16982 22.74 11.9798 19.79 14.9298Z",
    stroke: "#e5eaf9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89001 17.4902L9.19001 19.7902",
    stroke: "#e5eaf9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z",
    stroke: "#e5eaf9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkkeyIcon);
export default __webpack_public_path__ + "static/media/DarkkeyIcon.92a3c2075f1c2c3636b4073379b953a8.svg";
export { ForwardRef as ReactComponent };